export default __webpack_public_path__ + "static/media/avatar.85a6122f.png";